module.exports = __webpack_public_path__ + "img/icon-scene-3.10ec0016.png";